
import style from './index.module.scss';
import { showAgreement as showAgreementDrawer } from '@/components/Drawer';

export default function DefaultFooter(props) {
    const { value } = props;
    return (
      <div className={style.container}>

        <div className={style.line}>
          {value?.map((item, index) => {
                    return (
                      <span
                        onClick={() => {
                            showAgreementDrawer({
                                detail: item,
                            });
                        }}
                        key={index}
                      >《{item.title}》</span>
                    );
                })}
        </div>
      </div>
    );
}
